import { render, staticRenderFns } from "./HandMouse.vue?vue&type=template&id=5f31e564&scoped=true&"
import script from "./HandMouse.vue?vue&type=script&lang=js&"
export * from "./HandMouse.vue?vue&type=script&lang=js&"
import style0 from "./HandMouse.vue?vue&type=style&index=0&id=5f31e564&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31e564",
  null
  
)

export default component.exports